import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactQuill from 'react-quill';

var QuillEditor = /*#__PURE__*/function (_Component) {
  _inherits(QuillEditor, _Component);

  var _super = _createSuper(QuillEditor);

  function QuillEditor(props) {
    var _this;

    _classCallCheck(this, QuillEditor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      _this.setState({
        text: value
      });

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "imageHandler", function () {
      var quill = _this.refs.quill.getEditor();

      var range = quill.getSelection();
      var value = prompt('Image URL');
      quill.insertEmbed(range.index, 'image', value);
    });

    var placeHolderText = '';

    if (_this.props.placeholder) {
      placeHolderText = _this.props.placeholder;
    }

    _this.state = {
      placeHolderText: placeHolderText,
      text: _this.props.text ? _this.props.text : ''
    };
    return _this;
  }

  _createClass(QuillEditor, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.text == '' && nextProps.text != '') {
        this.setState({
          text: nextProps.text
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      // let modules = {
      // 	toolbar: [
      // 		[{ 'header': [2, 3, false] }],
      // 		['bold', 'italic', 'underline','strike', 'blockquote'],
      // 		[{'list': 'ordered'}, {'list': 'bullet'}],
      // 		['link', 'video'],
      // 		['clean']
      // 	]
      // }
      var modules = {
        toolbar: {
          container: [[{
            header: [2, 3, false]
          }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
            list: 'ordered'
          }, {
            list: 'bullet'
          }], ['link', 'image', 'video'], ['clean']],
          handlers: {
            image: this.imageHandler
          }
        }
      };
      var formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet',
      /* 'indent', */
      'link', 'image', 'video'];
      return /*#__PURE__*/React.createElement("div", null, this.props.label ? /*#__PURE__*/React.createElement("label", null, this.props.label) : '', /*#__PURE__*/React.createElement(ReactQuill, {
        value: this.state.text,
        modules: modules,
        formats: formats,
        onChange: this.handleChange,
        onBlur: this.props.onBlur,
        placeholder: this.state.placeHolderText,
        ref: "quill"
      }));
    }
  }]);

  return QuillEditor;
}(Component);

export default QuillEditor;